



























































import Vue, { PropType } from 'vue';
import NotificationText from '../common/NotificationText/NotificationText.vue';
import CheckBox from '../common/CheckBox/CheckBox.vue';
import { parsedObjectInfoI } from '@/interfaces/parsedObjectInfoI';

export default Vue.extend({
  props: {
    getResult: {
      type: Boolean,
    },
    parsedObject: {
      type: Array as PropType<parsedObjectInfoI[]>,
    },
  },
  components: {
    NotificationText,
    CheckBox,
  },
  data(): {
    error: boolean;
    keySelected: boolean[];
  } {
    return {
      error: false,
      keySelected: [],
    };
  },
  created() {
    this.keySelected = this.parsedObject.map(() => {
      return false;
    });
  },
  methods: {
    normalizeToParsingRuleArray(
      currentIndex: number,
      currentDepth: number,
    ): any[] | null {
      const normalizedParsedObject: any[] | null = [];
      let isValid = false;
      for (
        var index = currentIndex;
        index < this.parsedObject.length;
        index++
      ) {
        const parsedInfo = this.parsedObject[index];
        if (this.keySelected[index]) {
          if (parsedInfo.depth < currentDepth) {
            break;
          } else if (parsedInfo.depth == currentDepth) {
            isValid = true;
            if (parsedInfo.name !== 'items') {
              normalizedParsedObject.push(parsedInfo.name);
            }
            const nextParsedInfo = this.normalizeToParsingRuleArray(
              index + 1,
              currentDepth + 1,
            );

            if (nextParsedInfo !== null) {
              normalizedParsedObject.push(nextParsedInfo);
            }
          }
        }
      }

      if (isValid) return normalizedParsedObject;
      return null;
    },
    onClickNextButton() {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const checkBoxResult = this.keySelected.reduce<number[]>(
        (acc, x, idx, _) => {
          if (x) {
            let nextAcc: number[] = acc;
            nextAcc.push(idx);
            return nextAcc;
          }
          return acc;
        },
        [],
      );
      if (checkBoxResult.length !== 1) {
        this.error = true;
      }

      let payload: {
        ok: boolean;
        rootDirectory: number;
      } = {
        ok: !this.error,
        rootDirectory: checkBoxResult[0],
      };

      this.$emit('pushResult', payload);
    },
  },
  watch: {
    getResult: function (getResult) {
      if (getResult === true) {
        this.onClickNextButton();
      }
    },
  },
});
